import { getAuthInstance } from "@/auth/authService";
import Router from "vue-router";
import Vue from 'vue'
import routes from './routes';
import store from '@/store/store'
import { canAccess } from '@/acl/roles';

const auth = getAuthInstance();
Vue.use(Router)

const allRoutes = routes({ authGuard, guestGuard });

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: allRoutes,
});

// This callback runs before every route change, including on page load.
router.beforeEach(async (to, from, next) => {
  // Check if we have the correct persona privilege for this route
  if (getAuthInstance().isAuthenticated
      && getAuthInstance().isTokenValid()
      && to.name !== 'dashboard'
      && to.name !== 'login'
      && to.name !== 'logout'
  ) {
    const hasAccess = await canAccess({name: to.name});
  
    if (!hasAccess) {
      return next({ name: 'dashboard' });
    }
  }

  next();
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

/**
 * Redirect to login if guest.
 *
 * @param  {Array} routes
 * @return {Array}
 */
function authGuard(routes) {
  return beforeEnter(routes, async (to, from, next) => {
    // We check our state, then we check auth0. Auth0 can refresh the state for us
    if (!(store.getters['auth/isAuthenticated']) && !await getAuthInstance().checkAuth()) {
      return await store.dispatch('auth/logout');
    }
    return next()
  });
}

/**
 * Redirect home if authenticated.
 *
 * @param  {Array} routes
 * @return {Array}
 */
function guestGuard(routes) {
  return beforeEnter(routes, async (to, from, next) => {
    if (store.getters['auth/accessToken']) {
      return next({ name: 'dashboard' });
    }
    next();
  });
}



/**
 * Apply beforeEnter guard to the routes.
 *
 * @param  {Array} routes
 * @param  {Function} beforeEnter
 * @return {Array}
 */
function beforeEnter(routes, beforeEnter) {
  return routes.map(route => ({ ...route, beforeEnter }));
}

export default router
